export default {
  common: {
    save: "సేవ్ చేయండి",
    cancel: "రద్దు చేయండి",
    back: "వెనుకకు",
    submit: "సమర్పించండి",
    loading: "లోడ్ అవుతోంది…",
    yes: "అవును",
    no: "లేదు",
    confirm: "నిర్ధారించండి",
    close: "మూసివేయండి",
    search: "శోధించండి",
    all: "అన్నీ",
    done: "పూర్తయింది",
    logout: "లాగ్ అవుట్",
    language: "భాష",
    selectLanguage: "మీ భాషను ఎంచుకోండి",
    saving: "సేవ్ అవుతోంది…",
    saved: "సేవ్ అయింది",
    viewAll: "అన్నీ చూడండి",
    filters: "ఫిల్టర్లు",
  },
  nav: {
    home: "హోమ్",
    installs: "ఇన్‌స్టాలేషన్స్",
    requests: "అభ్యర్థనలు",
    orders: "ఆర్డర్లు",
    profile: "ప్రొఫైల్",
    leads: "లీడ్స్",
    service: "సేవ",
    payouts: "చెల్లింపులు",
    toolkit: "టూల్‌కిట్",
  },
  profile: {
    yourAccount: "మీ ఖాతా",
    title: "ప్రొఫైల్.",
    city: "నగరం",
    state: "రాష్ట్రం",
    pinCode: "పిన్ కోడ్",
    pinCodeHelp: "ఈ పిన్ కోడ్ చెందిన అనుమతించబడిన ప్రాంతమే మీ ప్రాంతం.",
    upiId: "UPI ఐడి (చెల్లింపుల కోసం)",
    saveProfile: "ప్రొఫైల్ సేవ్ చేయండి",
    preferredLanguage: "ఇష్టమైన భాష",
    logoutConfirm: "మీరు ఖచ్చితంగా లాగ్ అవుట్ చేయాలనుకుంటున్నారా?",
    linkedAddresses: "లింక్ చేసిన చిరునామాలు",
    noAddresses: "ఇంకా చిరునామాలు సేవ్ చేయలేదు.",
    referFriend: "స్నేహితుడిని రెఫర్ చేయండి",
    referFriendSub: "మీ కోడ్‌ను షేర్ చేయండి — వారు సోలార్ పెట్టుకుంటే మీకు రివార్డ్ లభిస్తుంది.",
    myReferrals: "నా రెఫరల్స్",
    shareFriend: "స్నేహితుడితో షేర్ చేయండి",
    secureNote: "మీ డేటా సురక్షిత ఫోన్ OTP ద్వారా ధృవీకరించబడింది — పాస్‌వర్డ్ గుర్తుంచుకోవాల్సిన లేదా పోగొట్టుకోవాల్సిన అవసరం లేదు.",
    toolkit: "టూల్‌కిట్",
    incentiveSchemes: "ప్రోత్సాహక పథకాలు",
  },
  tickets: {
    myRequests: "నా అభ్యర్థనలు",
    raiseComplaint: "ఫిర్యాదు నమోదు చేయండి",
    cancelRequest: "అభ్యర్థనను రద్దు చేయండి",
    cancelConfirmTitle: "ఈ అభ్యర్థనను రద్దు చేయాలా?",
    cancelConfirmBody: "ఈ సేవా అభ్యర్థనపై పనిని మేము ఆపేస్తాము. మీరు తర్వాత మళ్ళీ కొత్త అభ్యర్థన చేయవచ్చు.",
    cancelledToast: "అభ్యర్థన రద్దు చేయబడింది",
    keepRequest: "వద్దు, ఉంచండి",
    noRequests: "ఇంకా సేవా అభ్యర్థనలు లేవు.",
    statusOpen: "తెరిచి ఉంది",
    statusInProgress: "ప్రగతిలో ఉంది",
    statusOnHold: "నిలిపివేయబడింది",
    statusActionNeeded: "చర్య అవసరం",
    statusCompleted: "పూర్తయింది",
    statusClosed: "మూసివేయబడింది",
    statusCancelled: "రద్దు చేయబడింది",
    statusDropped: "వదిలివేయబడింది",
    filterAll: "అన్నీ",
    filterActive: "క్రియాశీలం",
    filterResolved: "పరిష్కరించబడింది",
    nonServiceable: "సేవ అందని ప్రాంతం",
    raisedOn: "నమోదు చేసిన తేదీ",
    ticketNumber: "టికెట్",
    wipInstall: "ఇన్‌స్టాలేషన్ జరుగుతోంది",
    raisedByYou: "మీరు నమోదు చేశారు",
    raisedByTeam: "మా టీమ్ నమోదు చేసింది",
    timeline: "టైమ్‌లైన్",
    pending: "పెండింగ్‌లో ఉంది",
    resolutionSummary: "పరిష్కార సారాంశం",
    youRatedPrefix: "మీరు దీన్ని రేట్ చేశారు",
    howWasResolution: "పరిష్కారం ఎలా ఉంది?",
    submitFeedback: "ఫీడ్‌బ్యాక్ సమర్పించండి",
  },
  home: {
    greeting: "నమస్తే",
    newInstallation: "కొత్త ఇన్‌స్టాలేషన్",
    raiseComplaint: "ఫిర్యాదు నమోదు చేయండి",
    welcomeBack: "మళ్ళీ స్వాగతం",
    customerSubtitle: "పూర్వోదయతో మీ సోలార్ ప్రయాణం, అంతా ఒకే చోట.",
  },
  sc: {
    requestsTitle: "సేవా అభ్యర్థనలు",
    requestsForCustomers: "మీ కస్టమర్ల కోసం",
    kpiOpen: "ఓపెన్",
    kpiResolved: "పరిష్కరించబడింది",
    kpiInProblem: "సమస్యలో ఉంది",
    raiseRequest: "సేవా అభ్యర్థన నమోదు చేయండి",
    slaBreached: "SLA ఉల్లంఘన",
    viewPhotos: "ఫోటోలు చూడండి",
    hidePhotos: "ఫోటోలు దాచండి",
    noRequestsWindow: "ఈ వ్యవధిలో సేవా అభ్యర్థనలు లేవు.",
  },
};
